// Shared program/requirement helpers for the Overview dashboard and Milestones (same source: /programs/enrollments).
export const DONE = new Set(["complete"]);
export const EXCLUDED = new Set(["waived", "not_applicable"]);

// Existing requirement statuses mapped onto the five milestone states (no second status system).
export const MILESTONE_STATUS = {
  not_started: ["Not Started", "slate"],
  in_progress: ["In Progress", "sky"],
  ready_for_review: ["In Progress · Pending verification", "sky"],
  action_needed: ["Blocked · Needs attention", "rose"],
  blocked: ["Blocked", "rose"],
  complete: ["Completed", "emerald"],
  waived: ["Not Applicable · Waived", "slate"],
  not_applicable: ["Not Applicable", "slate"],
};
export const TONE = {
  slate: "bg-slate-100 text-slate-600", sky: "bg-sky-50 text-sky-700", rose: "bg-rose-50 text-rose-700",
  emerald: "bg-emerald-50 text-emerald-700", amber: "bg-amber-50 text-amber-800",
};

export const todayIso = () => new Date().toISOString().slice(0, 10);
export const fmtDate = (v) => {
  if (!v) return null;
  const [y, m, d] = String(v).slice(0, 10).split("-");
  return y && m && d ? new Date(Number(y), Number(m) - 1, Number(d)).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : v;
};

export function linkedTask(r, tasks) {
  const live = (tasks || []).filter((t) => !t.archived && !t.deleted);
  const pick = (ts) => (DONE.has(r.status) ? ts.find((t) => t.status === "completed") : null) || ts.find((t) => !["completed", "cancelled"].includes(t.status)) || ts[0] || null;
  return pick(live.filter((t) => t.requirement_id === r.requirement_id)) || pick(live.filter((t) => t.resolved_requirement_id === r.requirement_id));
}

export function enrichRequirements(reqs, tasks) {
  const t0 = todayIso();
  return (reqs || []).filter((r) => r.required).map((r) => {
    const task = linkedTask(r, tasks);
    const due = (r.due_date || task?.due_date || "").slice(0, 10) || null;
    const open = !DONE.has(r.status) && !EXCLUDED.has(r.status);
    const blocked = open && (!!r.gated || r.status === "blocked" || r.status === "action_needed");
    const missing = open ? [r.document_required && !(r.evidence || []).length ? "Supporting document not on file" : null, r.gate_reason || null].filter(Boolean) : [];
    return { ...r, task, due, open, blocked, overdue: open && !!due && due < t0, missing,
      category: r.key_contact_topic || r.phase_name || "Other requirements", responsible: task?.assignee_name || null };
  });
}

export const rank = (r) => (r.overdue ? 0 : r.blocked ? 1 : r.status === "ready_for_review" ? 3 : 2);

export function programLabel(enr) {
  if (!enr) return null;
  const p = (enr.program || "").toLowerCase();
  const sub = (enr.program_subtype || "").toLowerCase();
  if (p.startsWith("retail")) return p.includes("acquisition") || sub === "acquisition" ? "Retail Acquisition" : "Retail Traditional";
  return { associate: "Associate", protege: "Protégé", agency_producer: "Agency Producer" }[p] || enr.program;
}
